import React from 'react';
import { FaEdit, FaSave, FaTimes, FaTrash } from 'react-icons/fa';

import patientListIcon from '../assets/patient_list.png';
import chatBubbleIcon from '../assets/chat_bubble.png';
import clinicalNotesIcon from '../assets/clinical_notes.png';
import defaultProfileIcon from '../assets/default_profile.svg';
import { common } from '../utils/common';
import SearchBox from './SearchBox';

function AicaWebView({
  user,
  handlePatientSelect,
  showSearchPopup,
  setShowSearchPopup,
  isRecording,
  getDisplayText,
  patientList,
  selectedPatient,
  setSelectedPatient,
  editingIndex,
  editName,
  setEditName,
  handleSaveName,
  setEditingIndex,
  handleEditName,
  handleDeletePatient,
  handleMedicalHistory,
  medicalHistory,
  selectedHistory,
  handleHistorySelect,
  handleDeleteHistory,
  startRecording,
  stopRecording,
  isProcessing,
  audioFilePath,
  audioPlayerRef,
  canvasRef,
  transcriptionText,
  summaryText,
  deleteConfirm,
  cancelDelete,
  confirmDelete,
  deleteHistoryConfirm,
  cancelDeleteHistory,
  confirmDeleteHistory,
}) {
  return (
    <div className="aica-container">
      
      {/* 상단 검색 영역 */}
      <div className="top-header">
        <SearchBox 
          user={user} 
          onPatientSelect={handlePatientSelect} 
          showSearchPopup={showSearchPopup} 
          setShowSearchPopup={setShowSearchPopup}
        />
        
        <div className="profile">
          <img src={defaultProfileIcon} alt="profile" className="profile-image" />
          <span className="profile-status"></span>
        </div>
      </div>

      



      {/* 메인 영역 */}
      <div className="aica-main">
        {/* --------- 왼쪽 섹션 - 환자 목록 --------- */}
        <div className="aica-left-section">
          
          {/* 환자 목록 */}
          <div className={`aica-patient-list-box ${isRecording ? 'disabled' : ''}`}>
            
            <div className="aica-box-header">
              <div className="icon-circle">
                <img 
                  src={patientListIcon}
                  alt="환자목록"
                  className="icon-mark"
                />
              </div>
              <h3>
                {/*환자 목록*/}
                {getDisplayText('patientList')}
              </h3>
              <div className="spacer" />
              {/*<button className="add-button" onClick={handleAddPatient}>+</button>*/}
            </div>

            <div className="aica-list-content">
              <div className="aica-patient-list">
                {patientList && patientList.map((patient, index) => (
                  <div 
                    key={index}
                    className={`aica-patient-item ${selectedPatient && selectedPatient.patientName === patient.patientName ? 'selected' : ''}`}
                    onClick={() => !editingIndex && handleMedicalHistory(patient)}
                  >
                    {editingIndex === index ? (
                      <div className="edit-mode">
                        <input
                          value={editName}
                          maxLength={20}
                          onChange={(e) => setEditName(e.target.value || null)}
                          className="name-input"
                          placeholder="환자 이름 입력"
                          autoFocus
                        />
                        <div className="edit-buttons">
                          <FaSave 
                            onClick={() => handleSaveName(index, patient.patientName)}
                            className="save-icon"
                            title="저장"
                          />
                          <FaTimes 
                            onClick={() => setEditingIndex(null)}
                            className="cancel-icon"
                            title="취소"
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        <span className="aica-patient-name">
                          {patient.patientName || ''}
                        </span>
                        <div className="spacer" />
                        <div className="action-buttons">
                          <FaEdit 
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditName(index, patient.patientName);
                            }}
                            className="edit-icon"
                            title="이름 수정"
                          />
                          <FaTrash 
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeletePatient(index, patient);
                            }}
                            className="delete-icon"
                            title="환자 삭제"
                          />
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>



        {/* --------- 중앙 섹션 - 환자 정보 --------- */}
        <div className="aica-middle-section">
          {/* 환자 정보 */}
          <div className={`patient-info-box ${isRecording ? 'disabled' : ''}`}>
            
            <div className="aica-box-header">
              <div className="icon-circle">
                <img 
                  src={chatBubbleIcon}
                  alt="환자정보"
                  className="icon-mark"
                />
              </div>
              <h3>
                {/*환자 정보*/}
                {getDisplayText('patientInfo')}
              </h3>
            </div>

            <div className="info-content">
              <div className="info-row">
                <div className="info-item">
                  <label style={{ fontWeight: 'bold' }}>환자 이름</label>
                  <input 
                    type="text" 
                    value={selectedPatient ? selectedPatient.patientName : ''} 
                    disabled={isRecording}
                    style={{
                      backgroundColor: isRecording ? '#f5f5f5' : 'white',
                      cursor: isRecording ? 'not-allowed' : 'text'
                    }}
                    onChange={(e) => {
                      if (selectedPatient) {
                        setSelectedPatient({
                          ...selectedPatient,
                          patientName: e.target.value
                        });
                      } else {
                        setSelectedPatient({
                          patientName: e.target.value
                        });
                      }
                    }}
                    maxLength={15}
                  />
                </div>
                
                {/* TODO 추후 환자관리 도입 시 사용 예정
                <div className="info-item">
                  <label style={{ fontWeight: 'bold' }}>생년월일</label>
                  <input 
                    type="text" 
                    value={selectedPatient ? selectedPatient.birthDate : ''} 
                    disabled 
                  />
                </div>
                */}
              </div>

              {/* TODO 추후 환자관리 도입 시 사용 예정
              <div className="info-row">
                <div className="info-item">
                  <label style={{ fontWeight: 'bold' }}>연락처</label>
                  <input 
                    type="text" 
                    value={selectedPatient ? selectedPatient.phone : ''} 
                    disabled 
                  />
                </div>
                <div className="info-item">
                  <label style={{ fontWeight: 'bold' }}>성별</label>
                  <div className="gender-options">
                    <label htmlFor="male">남성</label>
                    <input 
                      type="radio" 
                      name="gender" 
                      id="male" 
                      checked={selectedPatient?.gender === 'male'}
                      disabled 
                    />
                    <label htmlFor="female">여성</label>
                    <input 
                      type="radio" 
                      name="gender" 
                      id="female" 
                      checked={selectedPatient?.gender === 'female'}
                      disabled 
                    />
                  </div>
                </div>
              </div>
              */}

              {/* TODO 추후 환자관리 도입 시 사용 예정
              <div className="info-row">
                <div className="info-item full-width">
                  <label style={{ fontWeight: 'bold' }}>상담메모</label>
                  <textarea placeholder="상담 메모를 입력하세요" rows="4"></textarea>
                </div>
              </div>
              */}

              {/* TODO 추후 환자관리 도입 시 사용 예정
              <div className="info-row">
                <button className="save-button">저장</button>
              </div>
              */}

            </div>
          </div>

          {/* 이전 상담 내역 */}
          <div className={`aica-medical-history-box ${isRecording ? 'disabled' : ''}`}>
            
            <div className="aica-box-header">
              <div className="icon-circle">
                <img 
                  src={chatBubbleIcon}
                  alt="이전상담내역"
                  className="icon-mark"
                />
              </div>
              <h3>
                {/*이전 상담 내역*/}
                {getDisplayText('medicalHistory')}
              </h3>
            </div>
           
            {/* 진료 내역 내용 */}
            <div className="aica-history-content">
              <div className="aica-history-list">
                {medicalHistory.map((history, index) => (
                  <div 
                    key={index} 
                    className={`aica-history-item ${selectedHistory?.seqNo === history.seqNo ? 'selected' : ''}`}
                    onClick={() => handleHistorySelect(history)}
                  >
                    <div className="aica-history-date">
                      {common.formatDateTimeDisplay(history.startDt)}
                    </div>
                    <div className="spacer" />
                    <div className="action-buttons">
                      <FaTrash 
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteHistory(index, history);
                        }}
                        className="delete-icon"
                        title="상담 내역 삭제"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* --------- 오른쪽 섹션 - 상담 영역 --------- */}
        <div className="right-section">
          
          {/* 상담 영역 */}
          <div className="aica-chat-content-box">
            <div className="aica-box-header">
              <div className="icon-circle">
                <img 
                  src={clinicalNotesIcon}
                  alt="상담"
                  className="icon-mark"
                />
              </div>
              <h3>
                {/*상담*/}
                {getDisplayText('consultation')}
              </h3>
              
              {/* 녹음 중인 경우 음성 레벨 표시  */}
              {isRecording &&(
                <div className="recording-indicator">
                  <div className="recording-pulse"></div>
                  <div>녹음중</div>
                </div>
              )}
            </div>

            <div className="controls-container">
              <div className="chat-buttons">
                <button 
                  className={`chat-button ${isRecording ? '' : 'active'}`}
                  onClick={startRecording}
                  disabled={isRecording}>
                    상담시작
                </button>
                
                <button 
                  className={`chat-button ${isRecording ? 'active' : ''}`}
                  onClick={stopRecording}
                  disabled={!isRecording || isProcessing}>
                    상담종료
                </button>
              </div>
              
              {/* 음성 파일 재생기 */}
              {audioFilePath && (
                <div className="audio-player-container">
                  <audio 
                    id="audioPlayer" 
                    ref={audioPlayerRef}
                    controls 
                    className={`audio-player ${audioFilePath === "disabled" ? "disabled" : ""}`}
                    disabled={audioFilePath === "disabled"}
                  >
                    <source src={audioFilePath === "disabled" ? "" : audioFilePath} type="audio/wav" />
                    브라우저가 오디오 재생을 지원하지 않습니다.
                  </audio>
                </div>
              )}
            </div>

            {/* 상담 내역 */}
            <div className="aica-chat-content">
              {/* 녹음 중인 경우 웨이브폼(파형) 시각화 isRecording && */}
              {isRecording && (
                <div className="waveform-container-overlay">
                  <canvas
                    ref={canvasRef}
                    className="audio-waveform"
                  />
                </div>
              )}
              <textarea 
                className="aica-chat-textarea"
                placeholder="" 
                value={transcriptionText}
                readOnly
                />
            </div>
          </div>

          {/* 상담 내역 요약 */}
          <div className="chat-summary-box">
            <div className="aica-box-header">
              <div className="icon-circle">
                <img 
                  src={clinicalNotesIcon}
                  alt=""
                  className="icon-mark"
                />
              </div>
              <h3>
                {/*상담 내역 요약*/}
                {getDisplayText('summary')}
              </h3>
            </div>

            <div className="summary-content">
              <textarea
                className="summary-textarea"
                placeholder=""
                value={summaryText}
                readOnly 
              />
            </div>
          </div>

        </div>
      </div>

      {/* 기존 환자 삭제 확인 팝업 */}
      {deleteConfirm.show && (
        <div className="delete-popup-overlay">
          <div className="delete-popup">
            <div className="delete-popup-header">
              <h3>환자 삭제</h3>
            </div>
            <div className="delete-popup-content">
              <p>
                <strong>"{deleteConfirm.patient?.patientName}"</strong> 환자를 삭제하시겠습니까?
              </p>
              <p className="delete-warning">
                ⚠️ 삭제된 환자의 모든 {getDisplayText('consultation')} 내역이 함께 삭제됩니다.
              </p>
            </div>
            <div className="delete-popup-buttons">
              <button 
                className="cancel-btn"
                onClick={cancelDelete}
              >
                취소
              </button>
              <button 
                className="delete-btn"
                onClick={confirmDelete}
              >
                삭제
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 상담 내역 삭제 확인 팝업 */}
      {deleteHistoryConfirm.show && (
        <div className="delete-popup-overlay">
          <div className="delete-popup">
            <div className="delete-popup-header">
              <h3>{getDisplayText('consultation')} 내역 삭제</h3>
            </div>
            <div className="delete-popup-content">
              <p>
                <strong>"{common.formatDateTimeDisplay(deleteHistoryConfirm.history?.startDt)}"</strong> {getDisplayText('consultation')} 내역을 삭제하시겠습니까?
              </p>
              <p className="delete-warning">
                ⚠️ 삭제된 {getDisplayText('consultation')} 내역은 복구할 수 없습니다.
              </p>
            </div>
            <div className="delete-popup-buttons">
              <button 
                className="cancel-btn"
                onClick={cancelDeleteHistory}
              >
                취소
              </button>
              <button 
                className="delete-btn"
                onClick={confirmDeleteHistory}
              >
                삭제
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AicaWebView;
